import type { ICustomControlProcedureReadProps } from '../../interfaces/';
import { Interapy4DklScoreIndicator } from './Interapy4DklScoreIndicator';

export function GgzoIntV1ProcedureSummary(props: ICustomControlProcedureReadProps) {
    return (
        <>
            <Interapy4DklScoreIndicator
                interapy4DklScoreType="depressie"
                norm={props.procedure.customControlData['4dklDepressieNorm']}
                score={props.procedure.customControlData['4dklDepressieScore']}
            />
            <Interapy4DklScoreIndicator
                interapy4DklScoreType="distress"
                norm={props.procedure.customControlData['4dklDistressNorm']}
                score={props.procedure.customControlData['4dklDistressScore']}
            />
            <Interapy4DklScoreIndicator
                interapy4DklScoreType="angst"
                norm={props.procedure.customControlData['4dklAngstNorm']}
                score={props.procedure.customControlData['4dklAngstScore']}
            />
            <Interapy4DklScoreIndicator
                interapy4DklScoreType="somatisatie"
                norm={props.procedure.customControlData['4dklSomatisatieNorm']}
                score={props.procedure.customControlData['4dklSomatisatieScore']}
            />
        </>
    );
}
